import React from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';

const Hero = () => {
  const scrollToContacto = () => {
    const element = document.getElementById('contacto');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="hero" 
      className="relative min-h-screen flex items-center justify-center bg-reset-black overflow-hidden"
    >
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://images.pexels.com/photos/6077797/pexels-photo-6077797.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
          alt="Legal Technology"
          className="w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-reset-black/80 via-reset-black/60 to-reset-black"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center">
        <div className="inline-flex items-center gap-2 bg-reset-gold/10 border border-reset-gold/30 px-4 py-2 rounded-full mb-8">
          <Sparkles className="text-reset-gold" size={16} />
          <span className="text-reset-gold text-sm uppercase tracking-widest font-semibold">
            Servicio exclusivo de consultoría
          </span>
        </div>

        <h1 className="text-5xl md:text-7xl lg:text-8xl font-light text-white leading-tight mb-8">
          Tu despacho, <br />
          <span className="italic text-reset-gold font-normal">potenciado por</span><br />
          inteligencia artificial
        </h1>

        <p className="text-xl md:text-2xl text-gray-400 max-w-3xl mx-auto leading-relaxed mb-12">
          No necesitas más horas, necesitas mejores sistemas. Diseñamos e implementamos tu ecosistema de IA privado para que recuperes el control de tu tiempo y tu rentabilidad.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button 
            onClick={scrollToContacto}
            data-testid="hero-cta-button"
            className="bg-reset-gold hover:bg-reset-gold-light text-black px-10 py-4 text-lg font-bold transition-all flex items-center gap-2 group"
          >
            Solicitar acceso prioritario
            <ArrowRight className="group-hover:translate-x-1 transition-transform" size={20} />
          </button>
          <button 
            onClick={() => window.open('/programa.html', '_blank')}
            className="border-2 border-reset-gold text-reset-gold hover:bg-reset-gold hover:text-black px-10 py-4 text-lg font-bold transition-all"
          >
            Accede al programa
          </button>
        </div>

        {/* Trust Indicators */}
        <div className="mt-16 grid grid-cols-3 gap-8 max-w-2xl mx-auto text-center border-t border-reset-gold/20 pt-8">
          <div>
            <p className="text-3xl font-bold text-reset-gold">100%</p>
            <p className="text-sm text-gray-500 mt-1">Confidencial</p>
          </div>
          <div>
            <p className="text-3xl font-bold text-reset-gold">4 Sem</p>
            <p className="text-sm text-gray-500 mt-1">Implementación</p>
          </div>
          <div>
            <p className="text-3xl font-bold text-reset-gold">ROI</p>
            <p className="text-sm text-gray-500 mt-1">Medible</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;